import { render, staticRenderFns } from "./IndustryReading.vue?vue&type=template&id=b894ffa0&scoped=true"
import script from "./IndustryReading.vue?vue&type=script&lang=js"
export * from "./IndustryReading.vue?vue&type=script&lang=js"
import style0 from "./IndustryReading.vue?vue&type=style&index=0&id=b894ffa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b894ffa0",
  null
  
)

export default component.exports